import { Flex } from 'foundations-components/components/Flex';
import { useState } from 'react';
import { ADD_ONS } from '../constants/ReportCardOptions';
import { ReportingInsightsCopilotButton } from '../report-actions/ReportingInsightsCopilotButton';
import ReportActionDropdown from './ReportActionsDropdown';
import ReportActionViewReport from './ReportActionsViewReport';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACTIONS_DROPDOWN_PROPS = {
  buttonSize: 'medium',
  buttonUse: 'link',
  buttonStyles: {
    marginInlineStart: '0',
    padding: '0'
  }
};
export default function Toolbar({
  appUsageTracker,
  report,
  reportResolve,
  reportActions,
  additionalReportActions,
  setIsReportViewerIsOpen,
  addOns,
  isReportActionsDisabled,
  onClickViewSRVAction
}) {
  const reportingInsightsCopilotToolEnabled = addOns.includes(ADD_ONS.COPILOT_INSIGHTS);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  function toggleDropdownOpen() {
    setIsDropdownOpen(!isDropdownOpen);
  }
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "end",
    alignItems: "center",
    "data-open": isDropdownOpen,
    "data-test-id": "report-card-actions",
    gap: "200",
    children: [reportingInsightsCopilotToolEnabled && /*#__PURE__*/_jsx(ReportingInsightsCopilotButton, {
      report: report,
      reportResolve: reportResolve,
      appUsageTracker: appUsageTracker
    }), addOns.includes(ADD_ONS.VIEW_SRV) && /*#__PURE__*/_jsx(ReportActionViewReport, {
      setIsReportViewerIsOpen: setIsReportViewerIsOpen,
      onClickViewSRVAction: onClickViewSRVAction
    }), (reportActions.length > 0 || additionalReportActions.length > 0) && /*#__PURE__*/_jsx(ReportActionDropdown, {
      reportActions: reportActions,
      additionalReportActions: additionalReportActions,
      appUsageTracker: appUsageTracker,
      report: report,
      isReportActionsDisabled: isReportActionsDisabled,
      toggleDropdownOpen: toggleDropdownOpen,
      actionsDropdownProps: ACTIONS_DROPDOWN_PROPS
    })]
  });
}